import type { ReactNode } from "react";
import type { Icon } from "iconsax-react";

interface InfoRowProps {
  icon: Icon;
  label: string;
  value: ReactNode;
}

export default function InfoRow({ icon: IconComponent, label, value }: InfoRowProps) {
  if (value == null || value === "") return null;
  return (
    <div className="flex justify-between items-center gap-2 py-4 first:pt-0 last:pb-0 not-last:border-b surface-app-stroke">
      <div className="flex justify-start items-center gap-2">
        <div className="w-5 aspect-square flex shrink-0 justify-center items-center content-action-brand">
          <IconComponent size={18} color="currentColor" />
        </div>
        <span className="text-body-regular-md content-base-secondary">{label}</span>
      </div>
      <span className="text-body-bold-md content-base-primary text-right">{value}</span>
    </div>
  );
}
